(function () {
	'use strict';

	angular
		.module('jcsfApp')
		.controller('jccentersController', jccentersController);

	jccentersController.$inject = [
		'$controller',
		'$scope',
		'events',
		'authService',
	];

	function jccentersController($controller, $scope, events, authService) {
		$controller('baseController', { $scope: $scope });

		var vm = this;
		vm.centers = [];
		vm.orderBy = sessionStorage.getItem('jccentersOrderBy') || 'JCCCC';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;
		vm.remove = deleteComponent;

		activate();

		function activate() {
			authService.fillAuthData();
			if (
				authService.authentication.userName == null ||
				!authService.authentication.isAuth ||
				!authService.authentication.userInfo.Roles.includes('Administrator')
			) {
				$scope.$state.go('home');
			}

			$scope.subscribe(
				events.message._GET_JCCENTER_LIST_COMPLETE_,
				function (results) {
					vm.centers = results;
				}
			);

			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
		}

		function deleteComponent(part) {
			var confirmed = window.confirm(
				'Are you sure you want to delete ' + part.JCCCC + '?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_JCCENTER_, [results.id]);
			}
		}

		/**
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('jccentersOrderBy', column);
		}
	}
})();
